import React, { useState, useEffect } from "react";
import axios from "axios";
import App from "./App";
import ConfigContext from "./context/ConfigContext";
import AuthContext from "./context/AuthContext";

function AppLoader() {
	const [config, setConfig] = useState(null);
	const [isConfigLoaded, setIsConfigLoaded] = useState(false);

	const fetchConfig = async () => {
		if (config == null) {
			const response = await axios.get("/api/Settings");
			const data = await response.data;
			setConfig(data);
			setIsConfigLoaded(true);
		}
	};

	const [isAuthenticated, setIsAuthenticated] = useState();
	const [user, setUser] = useState();
	const [isAuthLoaded, setIsAuthLoaded] = useState(false);

	const login = () => {
		window.location.href = "/api/auth";
	};

	const getUser = async () => {
		const response = await axios.get(config.REACT_APP_GET_USER_URL);
		const data = await response.data;

		setIsAuthenticated(data.isAuthenticated);
		setIsAuthLoaded(true);
		if (!data.isAuthenticated) {
			login();
		} else setUser(data);
	};

	useEffect(() => {
		fetchConfig();
	}, []);

	useEffect(() => {
		if (isConfigLoaded) getUser();
	}, [isConfigLoaded]);

	return (
		isConfigLoaded && (
			<ConfigContext.Provider value={config}>
				{(isAuthLoaded && user) &&
					<AuthContext.Provider value={{ isAuthenticated, user }}>
						<App />
					</AuthContext.Provider>
				}
			</ConfigContext.Provider>
		)
	);
}

export default AppLoader;